<script>
import { deliveryZoneService, userService } from '../../services';
import { error_message, success_message, get_user } from "../../Helper/helper";
import config from "../../config";
import DropzonePopup from "../../components/widgets/dropzone-popup";

import {
  required,
  email,
  numeric,
} from "vuelidate/lib/validators";

export default {
  components: {DropzonePopup},
  data() {
    return {
      config: config,
      typeform: {
        name: "",
        name_lang: "",
        image:"",
        status: "1",
      },
      typesubmit: false,
    };
  },
  validations: {
    typeform: {
      name:{
          required,
      },
      name_lang: {
          required
      },
      image:{
          required,
      },
    }
  },
  mounted() {
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
        evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
        evt.preventDefault();
      }
    },
    typeForm(e) {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      }
      else {
        deliveryZoneService.addDeliveryZone(this.typeform)
          .then(response => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.$router.push({ name: "list" });
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
  }
}
</script>

<template>
  <b-form action="#" @submit.prevent="typeForm">
    <!-- Delivery Zone Info Start -->
    <div class="card">
      <div class="card-body">
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6" v-if="$auth.setting">
            <div class="form-group">
              <label class="required">{{ trans.trans('__JSON__.Zone Name Primary', {lang: $auth.langauges[0].name})}}</label>
              <input id="name" v-model="$v.typeform.name.$model" type="text" class="form-control"
                :placeholder="trans.trans('__JSON__.Zone Name Primary', { lang: $auth.langauges[0].name })" name="name"
                :class="{ 'is-invalid': $v.typeform.name.$error }" />
              <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter zone name') }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
            <div class="form-group">
              <label class="required">{{ trans.trans('__JSON__.Zone Name Secondary', {lang: $auth.langauges[1].name})}}</label>
              <input id="name_lang" v-model="$v.typeform.name_lang.$model" type="text" class="form-control"
                :placeholder="trans.trans('__JSON__.Zone Name Secondary', { lang: $auth.langauges[1].name })"
                name="name_lang" :class="{ 'is-invalid': $v.typeform.name_lang.$error }" />
              <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter zone name') }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{ trans.trans('__JSON__.Image') }}</label>
              <dropzone-popup v-model="$v.typeform.image.$model" type="file" id="image" name="image"
                acceptedFiles=".jpeg,.jpg,.png" />
              <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                <span v-if="!$v.typeform.image.required">{{ trans.get('__JSON__.Please select image') }}.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 vendor-status">
            <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status">
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input type="checkbox" id="togBtn" class="switch-on" name="status" v-model="typeform.status"
                        true-value="1" false-value="0" />
                      <div class="slider round">
                        <!--ADDED HTML -->
                        <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                        <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                        <!--END-->
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <button type="submit" class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Delivery Zone')}}</button>
            <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{trans.get('__JSON__.Cancel')}}</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delivery Zone Info End -->
  </b-form>
</template>
